// here api

// revgoecode
import axios from "axios";
import {hereApiKey, hereMapApiRevgeocode, hereMapApirouter, hereMapApiSearch} from "@/globals/contants";

// Obtener la dirección a partir de una coordenada
export const getReverseGeocode = async (latitude, longitude) => {
    try {
        const response = await axios.get(hereMapApiRevgeocode,{
            params: {
                at: `${latitude},${longitude}`,
                apiKey: hereApiKey
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Error al obtener la dirección:', error);
        throw error;
    }
}

// Obtener la ruta entre dos puntos
export const getRoute = async (origin, destination) => {
    try {
        const response = await axios.get(hereMapApirouter, {
            params: {
                apiKey: hereApiKey,
                origin: `${origin.latitude},${origin.longitude}`,
                destination: `${destination.latitude},${destination.longitude}`,
                transportMode: 'car',
                return: 'polyline,summary,instructions,actions',
                routingMode: 'short'
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Error al obtener la ruta:', error);
        throw error;
    }
}

// Obtener sugerencias de búsqueda
export const getAutosuggest = async (query) => {
    try {
        const response = await axios.get(hereMapApiSearch, {
            params: {
                apiKey: hereApiKey,
                at: `26.517938,-81.760655`,
                q: query,
                in: 'countryCode:USA',
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Error al obtener las sugerencias:', error);
        throw error;
    }
}